import React from 'react';
import './styles.css';

import EmailBox from './EmailBox'
import Frequency from './Frequency';

export default class Form extends React.Component {  
  render() {
    return(
      <form onSubmit={this.props.handleSubmit}>
        {this.props.streamlinedUnsub ? null : <Frequency value={this.props.frequency} changeHandler={this.props.handleFrequencyUpdate} error={this.props.frequencyValidationError}/>}
        <EmailBox changeHandler={this.props.handleEmailUpdate} value={this.props.email} streamlinedUnsub={this.props.streamlinedUnsub} error={this.props.emailValidationError}/>
      </form>
    );
  }
}